import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { ProductCard } from "../components/ProductCard";
import { Reveal } from "../components/Reveal";

export default function Shop() {
  const [params, setParams] = useSearchParams();
  const category = params.get("category") || "";
  const [products, setProducts] = useState([]);
  const [filters, setFilters] = useState([{ key: "", label: "All" }]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/categories").then((r) => setFilters([{ key: "", label: "All" }, ...r.data.map((c) => ({ key: c.slug, label: c.name }))])).catch(() => {});
  }, []);

  useEffect(() => {
    setLoading(true);
    api.get("/products", { params: category ? { category } : {} })
      .then((r) => setProducts(r.data)).finally(() => setLoading(false));
  }, [category]);

  const setCat = (key) => { key ? setParams({ category: key }) : setParams({}); };

  return (
    <div className="pt-32 pb-28">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12">
        <Reveal>
          <p className="overline text-[hsl(var(--primary))] mb-4">The Collection</p>
          <h1 className="font-display text-5xl md:text-7xl">Sanganeri Shirts</h1>
        </Reveal>

        <div className="flex items-center gap-3 mt-12 mb-12 border-b border-border pb-6" data-testid="category-filters">
          {filters.map((f) => (
            <button key={f.key} data-testid={`filter-${f.label.toLowerCase()}`} onClick={() => setCat(f.key)}
              className={`px-5 py-2 font-body text-sm border transition-colors duration-300 ${category === f.key ? "bg-[hsl(var(--secondary))] text-white border-[hsl(var(--secondary))]" : "border-border text-foreground/70 hover:border-foreground"}`}>
              {f.label}
            </button>
          ))}
          <span className="ml-auto overline text-muted-foreground hidden md:block">{products.length} pieces</span>
        </div>

        {loading ? (
          <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-border border border-border">
            {[...Array(6)].map((_, i) => <div key={i} className="bg-muted aspect-[3/4] animate-pulse" />)}
          </div>
        ) : (
          <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-border border border-border" data-testid="shop-grid">
            {products.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
          </div>
        )}
        {!loading && products.length === 0 && <p className="font-body text-muted-foreground py-20 text-center">No products found.</p>}
      </div>
    </div>
  );
}
